export default "__VITE_ASSET__D8JntVvb__"